import React, { useEffect, useState, useRef, useMemo } from "react";
import * as echarts from 'echarts';
import { importJSON } from "@/pages/intelligence/utils/echartsUtils";
import { valueFormat } from "@/pages/intelligence/utils/commonUtils";
import { Icon } from "tea-component";
import { useSize } from "ahooks";
import './index.scss'
import { useIntl, getLocale } from "umi";
import nameMap from '@/pages/dashboard/components/MapEchart/_config/nameMap.json'
export default function MapChart(props: any) {
  const {
    data,
    chartStyle = {
      height: '330px',
      width: '100%',
    }
  } = props;
  const size = useSize(document.querySelector('body'));

  const { formatMessage } = useIntl()

  const ref = useRef<HTMLDivElement>(null);
  const mapColor = ['#EBECF1FF', '#5086F333', '#5086F359', '#5086F380', '#5086F3A6', '#5086F3CC', '#5086F3FF']
  const mapRange = ['0', '$100K', '$1M', '$10M', '$100M', '$1B', '$10B']
  const [mapList, setMapList] = useState({});
  const [options, setOptions] = useState({})

  const formatEnNumber = (num: any) => {
    if (isNaN(num)) {
      return '--'
    }

    return valueFormat(num);
    // return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
  }

  const tooltip = (val: any) => {
    let returnStr = `<div>
      <div style="font-size:12px;margin-bottom:4px;">
          <div style="color:#EBECF1FF;text-align: left;margin-right:20px;display:inline-block;">
              ${val.name}
          </div>
      </div>`;

    const leftStr = `<div>
        <span style="color:#EBECF1FF;font-size:12px;"${formatMessage({ id: 'dbi_revenue_$' })}</span>
      </div>`

    const rightStr = ` <div style="color:#EBECF1FF;font-weight:bold;text-align:right;font-size:14px;" >
        ${formatEnNumber(val.value)}
      </div>`

    returnStr += `<div style="font-size:12px;display:flex;justify-content:space-between;">
        <div  style="margin-right:16px;">${leftStr}</div>      
        <div>${rightStr}</div>
      </div>`;
    returnStr += '</div>'

    return returnStr;
  }
 
  const getOptions = useMemo(() => ({
    tooltip: {
      trigger: 'item',
      showDelay: 0,
      // backgroundColor: '#262832F2',
      textStyle: {
        color: '#EBECF1FF'
      },
      transitionDuration: 0.2,
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(187,187,187,0.2)',
        },
      },
      formatter: (params) => tooltip(params),
      backgroundColor: 'rgba(0,0,0,0.75)'
    },
    visualMap: [{
      show: false,
      realtime: false,
      calculable: false,
      pieces: [ // 自定义『分段式视觉映射组件（visualMapPiecewise）』的每一段的范围，以及每一段的文字，以及每一段的特别的样式
        { min: 10000000000, color: mapColor[6] },
        { min: 1000000000, max: 10000000000, color: mapColor[5] },
        { min: 100000000, max: 1000000000, color: mapColor[4] },
        { min: 10000000, max: 100000000, color: mapColor[3] },
        { min: 1000000, max: 10000000, color: mapColor[2] },
        { min: 100000, max: 1000000, color: mapColor[1] },
        { min: 0, max: 100000, color: mapColor[0] }
      ],
    }],
    series: [
      {
        type: 'map',
        mapType: 'world',
        roam: true, // 是否开启平游或缩放
        zoom: 1, // 当前视角的缩放比例
        scaleLimit: { // 滚轮缩放的极限控制
          min: 0.8,
        },
        itemStyle: {
          normal: {
            borderColor: 'rgba(190, 190, 190,0.5)',
            borderWidth: 1,
            areaColor: '#f2f2f2',
          },
          emphasis: {
            label: { show: true },
            itemStyle: {
              borderColor: '#000',
              borderWidth: '2',
              borderType: 'solid',
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              shadowBlur: 10,
            },
          },
        },
        nameMap: getLocale() === 'zh-CN' ? nameMap : null,
        data,
        
      },
    ],
  }), [data, mapColor, tooltip])


  const getMapChart = async () => {
    try {
      
      // if (echarts.getMap('world')) {
      // } else {
      //   const map = await importJSON('https://ogdb-cdn.intlgame.cn/front/static/world.json')
      //   // echarts.registerMap('world', map)
      //   setMapList(map)
      // }
      const map = await importJSON('https://ogdb-cdn.intlgame.cn/front/static/world.json');
      setMapList(map);
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getMapChart()
  }, [])

  useEffect(() => {
    const option = getOptions
    const myChart = echarts.init(ref!.current!);
    let clickType: boolean | null = null;
    setOptions(option)
    myChart.showLoading();
    echarts.registerMap('world', (mapList));
    myChart.setOption(option, true)
    myChart.getZr().on('mousemove', param => {
      if (param.target) {// 若鼠标滑过区域位置在当前图表范围内 鼠标设置为小手
        myChart.getZr().setCursorStyle('pointer')
      } else {
        myChart.getZr().setCursorStyle('move')
      }
    })
    myChart.on('georoam', () => {
    })
    myChart.on('dblclick', () => {
      clickType = true;
    })
    myChart.resize();
    myChart.hideLoading();
  }, [mapList, props, size])


  // 地图缩放
  const mapZoom = (type: 'zoomIn' | 'zoomOut') => {
    const opt = options
    if (JSON.stringify(opt) === '{}') {
      return
    }
    let mapZoomNow = options?.series[0]?.zoom;
    if (type == 'zoomIn'/* && mapZoomNow < 25*/) {
      mapZoomNow = mapZoomNow + 0.5;
    } else if (type == 'zoomOut') {
      mapZoomNow--;
      if (mapZoomNow < options?.series[0]?.scaleLimit.min) {
        mapZoomNow = options?.series[0]?.scaleLimit.min
      }
    }
    opt.series[0].zoom = mapZoomNow;
    setOptions(opt);
    const myChart = echarts.init(ref!.current!);
    myChart.setOption(opt, true)
  };

  return (
    <div className="dbi-sm-map" style={{ ...chartStyle }}>
      <div className="dbi-sm-map-legend">
        {
          mapColor.map((item, idx) => (
            <div className="dbi-sm-map-legend-item">
              <div className="dbi-sm-map-legend-item-block" style={{ backgroundColor: `${item}` }}></div>
              <div className="dbi-sm-map-legend-item-text">
                {mapRange[idx]}
              </div>
            </div>
          ))
        }
      </div>
      <div ref={ref} style={{ ...chartStyle, overflow: 'hidden', height: '100%', flex: '1' }}></div>
      <div className="dbi-sm-map-control">
        <div
          className="dbi-sm-map-control-item zoomIn"
          onClick={() => {
            mapZoom('zoomIn');
          }}
        >
          <Icon type="plus" />
        </div>
        <div
          className="dbi-sm-map-control-item zoomOut"
          onClick={() => {
            mapZoom('zoomOut');
          }}
        >
          <Icon type="minus" />
        </div>
      </div>
    </div>
  );
}